import { IMessageNotification } from '../../../../../store/notification/store';

export const Notify = async (response: any, successText: string, pushNotification: any) => {
  if (response.errors) {
    await pushNotification(({
      status: 'unread',
      text: response.errors.adminRoundFormats.msg,
      type: 'error'
    } as unknown) as IMessageNotification);
  } else {
    await pushNotification(({
      status: 'unread',
      text: successText,
      type: 'success'
    } as unknown) as IMessageNotification);
  }
};
